// @flow
import React, { Component } from "react";
import NoUserIcon from "@material-ui/icons/Face";

import { Link } from "./styled";
import { Centered } from "../../utils/styled";

type Props = {||};

class NoUserView extends Component<Props> {
    render() {
        return (
            <Centered>
                <NoUserIcon style={{ height: 50, width: 50 }} />
                <br />
                <br />
                <div>I can&apos;t find this blog</div>
                <br />
                <Link href="https://www.getjealous.com">return to GetJealous.com</Link>
            </Centered>
        );
    }
}

export default NoUserView;



// WEBPACK FOOTER //
// ./src/home-page-view/no-user-view/view.js